export enum TodoListTabKinds {
  Myself,
  MyDraft,
  MyWritten,
  Department,
  Backed,
}
